/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Status_AllocatedInputs */

const en_admin_resources_resource_allocations_status_allocated = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocated`)
};

const de_admin_resources_resource_allocations_status_allocated = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesen`)
};

const es_admin_resources_resource_allocations_status_allocated = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignado`)
};

const fr_admin_resources_resource_allocations_status_allocated = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribué`)
};

const nl_admin_resources_resource_allocations_status_allocated = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toegewezen`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_status_allocated = en_admin_resources_resource_allocations_status_allocated;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_status_allocated = en_admin_resources_resource_allocations_status_allocated;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_status_allocated = en_admin_resources_resource_allocations_status_allocated;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_status_allocated = en_admin_resources_resource_allocations_status_allocated;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_AllocatedInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_status_allocated = en_admin_resources_resource_allocations_status_allocated;

/**
* | output |
* | --- |
* | "Allocated" |
*
* @param {Admin_Resources_Resource_Allocations_Status_AllocatedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_status_allocated = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Status_AllocatedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Status_AllocatedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_status_allocated(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_status_allocated(inputs)
	return ro_admin_resources_resource_allocations_status_allocated(inputs)
});
export { admin_resources_resource_allocations_status_allocated as "admin.resources.resource_allocations.status_allocated" }